module.exports = "<p>\n  enquiry-analytics works!\n</p>\n"